import { DeletePatientProfile } from 'features/delete-patient-profile';
import { ToggleBan } from 'features/toggle-ban';
import { ToggleIsTest } from 'features/toggle-is-test';
import { FC } from 'react';
import {
  Show,
  Tab,
  TabbedShowLayout,
} from 'react-admin';
import { API_URL } from 'shared/constants/api-url';
import { PatientsShowActions } from '../actions';
import { Button } from '@mui/material';
import PatientPromocodes from './tabs/promocodes-list';
import { PatientDetails } from './tabs/patient-info';

interface Props {
  id?: string;
  isTest: boolean;
  isCard: boolean;
  isBanned: boolean;
  avatarKey?: string;
  onBookSession: () => void;
}

export const PatientInfo: FC<Props> = ({ id, isBanned, isTest, isCard, avatarKey, onBookSession }) => {
  return (
    <Show
      actions={
        <PatientsShowActions
          extra={[
            <Button
              onClick={onBookSession}
              variant="contained"
              color="success"
              size="small"
              disabled={!isCard}
            >
              Забронировать сессию
            </Button>,
            <ToggleIsTest
              isTest={ isTest }
              id={id}
              isTestUrl={API_URL.patientIsTest}
            />,
            <ToggleBan
              id={id}
              isBan={isBanned}
              banUrl={API_URL.patientBan}
              unbanUrl={API_URL.patientUnban}
            />,
            <DeletePatientProfile id={id} />,
          ]}
        />
      }
    >

      <TabbedShowLayout>
        <Tab label="Информация о пользователе">
          <PatientDetails />
        </Tab>
        <Tab label="Промокоды">
          <PatientPromocodes />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
